// extracted by mini-css-extract-plugin
export default {"container":"WSS9","feedbacksWrapper":"nXu5"};